import data from "../game/levels.json";
import React, { useState, useEffect } from "react";
import { getDevEmitter, dev_event } from "./devEvents";
import { DatabaseHandle } from "../game/database/database";
import worldMapdata from "../../static/assets/worldMap.json";
import toastr from "toastr";

const allLevels = {};

let i = 0;
for (const levels of Object.values(worldMapdata)) {
  for (const level of levels) {
    i++;

    allLevels[level.levelKey] = level;
    allLevels[level.levelKey].number = i < 10 ? `0${i}` : i;
  }
}

export const LevelList = () => {
  const [listOfLevels, setListOfLevels] = useState([]);
  const [refreshLevels, refreshLevelsState] = useState(0);
  useEffect(() => {
    DatabaseHandle.db.allDocs().then(async (docs) => {
      console.log(docs);
      const level_list = docs.rows
        .map(({ id }) => id)
        .map((id) => ({
          key: id,
          displayName: `${allLevels[id]?.number || "99"}_${
            allLevels[id]?.displayName || id
          }`,
        }));

      level_list.sort((a, b) => {
        return a.displayName < b.displayName
          ? -1
          : a.displayName > b.displayName
          ? 1
          : 0;
      });
      setListOfLevels(level_list);
    });
  }, [refreshLevels]);

  const saveAllToDisk = async () => {
    const result = await DatabaseHandle.fetchAllDocs();
    if (result) {
      try {
        await fetch(`/api/level-dump`, {
          method: `POST`,
          mode: `cors`,
          cache: `no-cache`,
          credentials: `same-origin`,
          referrerPolicy: "no-referrer",
          body: JSON.stringify(result.rows),
          headers: { "Content-Type": "application/json" },
        });
        toastr.success("Saved all levels to disk!");
      } catch (e) {
        toastr.error(e);
      }
    }
  };

  return (
    <div className="levelListContainer">
      <button
        onClick={() => {
          const level_name = prompt("What level name you want?");
          if (level_name) {
            DatabaseHandle.createNewLevel(level_name).then(() =>
              refreshLevelsState(refreshLevels + 1)
            );
          }
        }}
      >
        Add Level
      </button>
      <button onClick={saveAllToDisk}>Save All To Disk</button>
      <button
        onClick={() => {
          dev_app.deleteLocalChanges();
        }}
      >
        Clear levels from local storage
      </button>
      <button
        onClick={async () => {
          for (const { key } of listOfLevels) {
            getDevEmitter()?.emit(dev_event.SKIP_TO_LEVEL, key);
            await new Promise((resolve) => setTimeout(resolve, 20));
            getDevEmitter()?.emit(dev_event.REQUEST_SNAPSHOT);
            await new Promise((resolve) => setTimeout(resolve, 40));
          }
        }}
      >
        ScreenshotAllLevels
      </button>
      <ul className="levelList">
        {listOfLevels.map(({ key, displayName }) => (
          <li
            key={key}
            onClick={() => getDevEmitter()?.emit(dev_event.SKIP_TO_LEVEL, key)}
          >
            {displayName}
          </li>
        ))}
      </ul>
    </div>
  );
};
